import { getFocusStyle, IStyle, mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import { getItemContentStyles } from '../CalendarSurfaceItemComponentRenderer';
import { IsFocusVisibleClassName } from '@uifabric/utilities';
import {
    CalendarSurfaceItemStyleProps,
    CalendarSurfaceItemStyles,
} from './CalendarSurfaceItem.types';

export const getStyles = (props: CalendarSurfaceItemStyleProps): CalendarSurfaceItemStyles => {
    const { freeBusyType, colorScheme, responseType, isCancelled } = props;

    return {
        root: computeRootStyles(props),
        content: getItemContentStyles(freeBusyType, responseType, colorScheme, isCancelled),
    };
};

export const getAllDayStyles = (
    props: CalendarSurfaceItemStyleProps
): CalendarSurfaceItemStyles => {
    const { freeBusyType, colorScheme, responseType, hideBorder, isCancelled } = props;

    return {
        root: computeRootStyles(props),
        content: [
            mergeStyles(getItemContentStyles(freeBusyType, responseType, colorScheme, isCancelled)),
            hideBorder &&
                responseType != 'NoResponseReceived' && {
                    borderColor: 'transparent',
                },
        ],
    };
};

function computeRootStyles(props: CalendarSurfaceItemStyleProps): IStyle {
    const { className, theme } = props;

    return [
        mergeStyles(
            className,
            theme
                ? getFocusStyle(
                      theme,
                      0,
                      'absolute',
                      undefined /*high contrast style*/,
                      'transparent' /*border color*/
                  )
                : undefined,
            {
                width: '100%',
                selectors: {
                    '.addFocusOutline &:focus': {
                        outline: 'transparent !important', // Override .addFocusOutline !important
                        selectors: {
                            [`.${IsFocusVisibleClassName} &:focus:after`]: {
                                zIndex: 3, //override default z-index of 1 so that the outline shows above the free busy bar
                            },
                        },
                    },
                },
            }
        ),
    ];
}
